import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

import {SharedModule} from '../../../../core/modules/shared.module';
import {AddOrganisationModuleDialogComponent} from './add.organisation.module.dialog.component';

const routes = [{
  path: 'moduleOrganisationdialog',
  component: AddOrganisationModuleDialogComponent
}];

@NgModule({
  declarations: [AddOrganisationModuleDialogComponent],
  imports: [SharedModule, RouterModule.forChild(routes)],
  exports: [AddOrganisationModuleDialogComponent]
})

export class AddOrganisationModuleDialogModule {}


// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/modules/addOrganisation/add.organisation.module.dialog.module.ts